import { render, staticRenderFns } from "./GroupCtrlSlot.vue?vue&type=template&id=20f205a9&"
import script from "./GroupCtrlSlot.vue?vue&type=script&lang=js&"
export * from "./GroupCtrlSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QBtn})
